import { Inject } from "typescript-ioc";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { Button } from "Ui/Scripts/Button";
import { EndConsumerSelectorRowComponent } from "./EndConsumerSelectorRowComponent";
import { EndConsumerSelectorRowComponentFactory } from "EndConsumerSelector/Scripts/EndConsumerSelectorRowComponentFactory";
import { Div } from "Ui/Scripts/Div";
import { Utils } from "Helpers/Scripts/Utils";
import { Input } from "Ui/Scripts/Input";

export class EndConsumerSelectorComponentView extends UiComponent {
    public ownerCustomerId: number;

    public refreshEndConsumerSelectorUrl: string;
    public createEndConsumerUrl: string;
    public editEndConsumerUrl: string;
    public deleteEndConsumerUrl: string;

    public deleteModalTitle: string;
    public deleteModalMessage: string;
    public deleteModalCancelText: string;
    public deleteModalConfirmText: string;

    public errorModalTitle: string;
    public errorModalMessage: string;
    public errorModalCloseText: string;

    public contentContainer: Div;

    public createEndConsumerButton: Button;
    public createEndConsumerWindow: Div;
    public endConsumerRows: EndConsumerSelectorRowComponent[];

    public selectedEndConsumerInput: Input;

    public editorWindowSelector: string = ".js-end-consumer-edit-window";
    public editorSelector: string = ".js-end-consumer-edit-window .end-consumer-editor-container";

    private readonly DATA_OWNER_CUSTOMER_ID: string = "owner-customer-id";

    private readonly DATA_REFRESH_END_CONSUMER_URL: string = "refresh-end-consumer-selector-url";
    private readonly DATA_CREATE_END_CONSUMER_URL: string = "create-end-consumer-url";
    private readonly DATA_EDIT_END_CONSUMER_URL: string = "edit-end-consumer-url";
    private readonly DATA_DELETE_END_CONSUMER_URL: string = "delete-end-consumer-url";

    private readonly DATA_DELETE_MODAL_TITLE: string = "delete-modal-title";
    private readonly DATA_DELETE_MODAL_MESSAGE: string = "delete-modal-message";
    private readonly DATA_DELETE_MODAL_CANCEL_TEXT: string = "delete-modal-cancel-text";
    private readonly DATA_DELETE_MODAL_CONFIRM_TEXT: string = "delete-modal-confirm-text";

    private readonly DATA_ERROR_MODAL_TITLE: string = "error-modal-title";
    private readonly DATA_ERROR_MODAL_MESSAGE: string = "error-modal-message";
    private readonly DATA_ERROR_MODAL_CLOSE_TEXT: string = "error-modal-close-text";

    private readonly END_CONSUMER_SELECTOR_CONTENT_CONTAINER_SELECTOR: string =
        ".js-end-consumer-selector-content-container";

    private readonly CREATE_BUTTON_SELECTOR: string = ".js-create-end-consumer";

    private readonly SELECTED_END_CONSUMER_SELECTOR: string = ".js-selected-end-consumer";

    private readonly _endConsumerSelectorRowComponentFactory: EndConsumerSelectorRowComponentFactory;

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory,
        @Inject endConsumerSelectorRowComponentFactory: EndConsumerSelectorRowComponentFactory
    ) {
        super(componentFactory, binder, loggerFactory);

        this._endConsumerSelectorRowComponentFactory = endConsumerSelectorRowComponentFactory;
    }

    protected init(): void {
        this.ownerCustomerId = this.getData(this.DATA_OWNER_CUSTOMER_ID);

        this.refreshEndConsumerSelectorUrl = this.getData(this.DATA_REFRESH_END_CONSUMER_URL);
        this.createEndConsumerUrl = this.getData(this.DATA_CREATE_END_CONSUMER_URL);
        this.editEndConsumerUrl = this.getData(this.DATA_EDIT_END_CONSUMER_URL);
        this.deleteEndConsumerUrl = this.getData(this.DATA_DELETE_END_CONSUMER_URL);

        this.deleteModalTitle = this.getData(this.DATA_DELETE_MODAL_TITLE);
        this.deleteModalMessage = this.getData(this.DATA_DELETE_MODAL_MESSAGE);
        this.deleteModalCancelText = this.getData(this.DATA_DELETE_MODAL_CANCEL_TEXT);
        this.deleteModalConfirmText = this.getData(this.DATA_DELETE_MODAL_CONFIRM_TEXT);

        this.errorModalTitle = this.getData(this.DATA_ERROR_MODAL_TITLE);
        this.errorModalMessage = this.getData(this.DATA_ERROR_MODAL_MESSAGE);
        this.errorModalCloseText = this.getData(this.DATA_ERROR_MODAL_CLOSE_TEXT);

        this.contentContainer = this.createComponent(
            Div,
            this.END_CONSUMER_SELECTOR_CONTENT_CONTAINER_SELECTOR
        );

        if (Utils.find(this._context, this.CREATE_BUTTON_SELECTOR).length > 0) {
            this.createEndConsumerButton = this.createComponent(
                Button,
                this.CREATE_BUTTON_SELECTOR
            );
        }
        this.createEndConsumerWindow = this.createComponent(Div, this.editorWindowSelector);
        this.selectedEndConsumerInput = this.createComponent(
            Input,
            this.SELECTED_END_CONSUMER_SELECTOR
        );
        this.endConsumerRows = this._endConsumerSelectorRowComponentFactory.createAll(
            this._context
        );
    }
}
